export * from './lib/avatar.component';
export * from './lib/avatar.module';
